export default "__VITE_ASSET__e5292d05__"